import SmoothScroll from 'smooth-scroll';

var CapBodyScroll = function CapBodyScroll(element, offset) {
  var scroll = new SmoothScroll('body', {
    header: '.header',
    speed: 500,
    speedAsDuration: true,
    easing: 'easeOutQuad',
    offset: offset || 0
  });
  scroll.animateScroll(element);
  scroll.destroy();
};

export default CapBodyScroll;